import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from '../../../components/popup';
import { IAppOnlyStore } from '../../../stores/AllStores';
import { ECheckoutStatus } from '../../../../../common/interfaces/checkout';
import { PortalCheckoutTerms, PortalCheckoutOrdered, PortalCheckoutYearsSelection, PortalCheckoutVINMissing } from './index';

@inject('store')
@observer
export class PortalCheckout extends React.Component<IAppOnlyStore, {}> {
    public render() {
        const { user, checkout } = this.props.store;

        return (
            <div>
                {user.customerIsPAC && (
                    <Modal
                        title="Parts year matching"
                        show={checkout.isOnSelectingYears}
                        closeLabel="Cancel checkout"
                        onClose={this.handleYearsSelectionClose}
                    >
                        <PortalCheckoutYearsSelection />
                    </Modal>
                )}

                {user.customerIsPAC && (
                  <Modal
                      title="VIN missing"
                      show={checkout.isOnVINMissing}
                      closeLabel={"Back to years"}
                      narrow={true}
                      onClose={this.handleGoingBackToYearsSelectionFromVINMissing}
                      >
                      <PortalCheckoutVINMissing
                          onApprove={this.handleMoveToTerms}
                          onDeclined={this.handleGoingBackToYearsSelectionFromVINMissing}
                      />
                  </Modal>
                )}

                <Modal
                    title="Terms of service"
                    show={checkout.isOnTerms}
                    closeLabel={!checkout.isProcessingCheckout && user.customerIsPAC ? 'Back to years' : 'Cancel checkout'}
                    onClose={
                        checkout.isProcessingCheckout
                            ? undefined
                            : user.customerIsPAC
                            ? this.handleGoingBackToYearsSelectionFromTerms
                            : this.handleTermsClose
                    }
                >
                    <PortalCheckoutTerms
                        onApprove={this.handleTermsApproval}
                        customerIsPBI={user.customerIsPBI}
                        customerPaymentTerms={user.customerPaymentTerms}
                        checkoutStatus={checkout.checkoutStatus}
                    />
                </Modal>

                <Modal
                    title="Checkout"
                    show={checkout.isOnCheckout}
                    closeLabel={checkout.checkoutStatus === ECheckoutStatus.CheckoutError ? 'Cancel checkout' : 'Dismiss'}
                    hideCloseButton={checkout.isProcessingCheckout}
                    onClose={this.handleCheckoutClose}
                >
                    <PortalCheckoutOrdered
                        onApprove={this.handleTermsApproval}
                        status={checkout.checkoutStatus}
                        orderRequestId={checkout.orderRequestId}
                    />
                </Modal>
            </div>
        );
    }

    private handleGoingBackToYearsSelectionFromTerms = () => {
        const { checkout } = this.props.store;

        if (!checkout.isOnCheckout) {
            this.props.store.checkout.backToYearsSelection();
        }
    };

    private handleMoveToTerms = () => {
      const { checkout } = this.props.store;

      if (checkout.isOnVINMissing) {
        checkout.moveToTerms();
      }
    };

    private handleGoingBackToYearsSelectionFromVINMissing = () => {
      const { checkout } = this.props.store;

      if (checkout.isOnVINMissing) {
          this.props.store.checkout.backToYearsSelection();
      }
  };

    private handleYearsSelectionClose = () => {
        const { checkout } = this.props.store;

        if (checkout.isOnSelectingYears) {
            checkout.cancelCheckout();
        }
    };

    private handleTermsClose = () => {
        const { checkout } = this.props.store;

        if (checkout.isOnTerms) {
            checkout.cancelCheckout();
        }
    };

    private handleCheckoutClose = () => {
        const { checkout } = this.props.store;

        if (checkout.isOnCheckout && !checkout.isProcessingCheckout) {
            if (checkout.checkoutStatus === ECheckoutStatus.CheckoutSuccess) {
                checkout.closeCheckoutAndClearCart();
            } else {
                checkout.cancelCheckout();
            }
        }
    };

    private handleTermsApproval = () => {
        this.props.store.checkout.acceptTerms();
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalCheckout/PortalCheckout.tsx